// Dependencies
import { DependencyList, useCallback, useRef } from 'react'

const useEvent = <T extends (...args: never[]) => unknown>(callback: T, deps: DependencyList = []): T => {
  const ref = useRef(callback)
  ref.current = callback

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback((...args: never[]) => ref.current(...args), deps) as T
}

export default useEvent
